export default __webpack_public_path__ + "static/media/21.09551ab2.gif";